// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, 'toCapitalize', {
  value() {
    return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase();
  },
  enumerable: false,
});

export default function capitalizeWords(arr) {
  return arr.map((element) => element.toCapitalize());
}
